import { useState, useMemo, useEffect } from "react";
import BotonMapaProceso from "./BotonMapaProceso";
import { authHeader } from './supabase';
import { calcularNivelCA } from './nivelCalidadAsegurada';

const Q = {
  azul:"#1C3FAA", azulVivo:"#2A7FFF", azulMedio:"#6B6FD6",
  grisClaro:"#E8E9F6", grisPalido:"#F4F6FB", grisOscuro:"#2B2F36",
  grisPlata:"#8E93A1", blanco:"#FFFFFF",
};

const STORAGE_FMEA = 'alqos_fmea';
const STORAGE_NC   = 'alqos_ncs';
const STORAGE_PC   = 'alqos_plancontrol';
const STORAGE_AC   = 'alqos_acciones_correctivas';
const STORAGE_FSC  = 'alqos_fsc_arqueo';
const STORAGE_TPM  = 'alqos_tpm';
const STORAGE_AUD  = 'alqos_auditorias';
const STORAGE_DOCS = 'alqos_docs';
const STORAGE_AC2  = 'alqos_analisis_causa';
const STORAGE_PROG = 'alqos_programa_auditorias';
const STORAGE_OTS  = 'alqos_ots';
const STORAGE_IM   = 'alqos_ingreso_materiales';
const STORAGE_PP   = 'alqos_preprensa_planchas';
const STORAGE_PAL  = 'alqos_stock_pallets';

const storage = { get: (k) => { try { return JSON.parse(localStorage.getItem(k)||'[]'); } catch { return []; } } };

function calcularResumenCNC() {
  try {
    const config = JSON.parse(localStorage.getItem('alqos_cnc_config')||'{}');
    const hGen  = Number(config.costoHoraGeneral||0);
    const hProd = Number(config.costoHoraProduccion||0)||hGen;
    const kgOtro = Number(config.costoKgOtroMaterial||0)||Number(config.costoKgCartulinaHoja||0);
    const hRep  = Number(config.horasReprocesoPorNC||2);
    const hParo = Number(config.horasParoTPM||4);
    const hMaq  = Number(config.costoHoraMaquinaOffset||0);
    const usd   = Number(config.cotizacionUSD||1);
    const configurado = hGen > 0 || hProd > 0;
    const mes = new Date().getMonth(); const anio = new Date().getFullYear();
    const esMes = (f) => { try { const d=new Date(f); return d.getMonth()===mes&&d.getFullYear()===anio; } catch { return false; } };
    const ncs     = JSON.parse(localStorage.getItem('alqos_ncs')||'[]');
    const tpm     = JSON.parse(localStorage.getItem('alqos_tpm')||'[]');
    const fsc     = JSON.parse(localStorage.getItem('alqos_fsc_arqueo')||'[]');
    const ots     = JSON.parse(localStorage.getItem('alqos_ots')||'[]');
    const ingresos = JSON.parse(localStorage.getItem('alqos_ingreso_materiales')||'[]');
    const ncsMes = ncs.filter(n=>esMes(n.fechaHora||n.fechaCreacion)).length;
    const scrapMes = fsc.filter(m=>esMes(m.fecha)).reduce((a,m)=>a+Number(m.kgScrap||0),0);
    const paros = tpm.filter(t=>t.tipo==='correctivo'&&esMes(t.fecha)).length;
    const otsRech = ots.filter(o=>o.estado==='rechazado'&&esMes(o.fecha||o.fechaCreacion)).length;
    const matCuar = ingresos.filter(i=>i.estado==='cuarentena').length;
    // Desglose por componente -- mismo cálculo que antes, pero separado para el simulador
    const costoNC     = ncsMes*hRep*hProd;
    const costoScrap   = scrapMes*kgOtro;
    const costoOTsRech = otsRech*hRep*hProd;
    const costoCuarentena = matCuar*(kgOtro||0)*10;
    const costoParos   = paros*hParo*(hMaq||hProd);
    const fallaInternas = costoNC + costoScrap + costoOTsRech + costoCuarentena + costoParos;
    const total = fallaInternas;
    const totalUSD = usd > 0 ? total / usd : 0;
    return {
      configurado, total, totalUSD, ncsMes, scrapMes, paros, otsRech,
      costoNC, costoScrap, costoOTsRech, costoCuarentena, costoParos,
    };
  } catch { return { configurado: false, total: 0, totalUSD: 0, ncsMes: 0, scrapMes: 0, paros: 0, otsRech: 0, costoNC:0, costoScrap:0, costoOTsRech:0, costoCuarentena:0, costoParos:0 }; }
}
function leerDatos() {
  return {
    fmeas:        storage.get(STORAGE_FMEA),
    ncs:          storage.get(STORAGE_NC),
    planControl:  storage.get(STORAGE_PC),
    acciones:     storage.get(STORAGE_AC),
    fsc:          storage.get(STORAGE_FSC),
    tpm:          storage.get(STORAGE_TPM),
    auditorias:   storage.get(STORAGE_AUD),
    docs:         storage.get(STORAGE_DOCS),
    analisisCausa:storage.get(STORAGE_AC2),
    programa:     storage.get(STORAGE_PROG),
    ots:          storage.get(STORAGE_OTS),
    ingresos:     storage.get(STORAGE_IM),
    planchas:     storage.get(STORAGE_PP),
    pallets:      storage.get(STORAGE_PAL),
  };
}

function calcularNCAbiertas(ncs)    { return ncs.filter(n=>n.estado!=="cerrada"&&n.estado!=="Cerrada").length; }
function calcularFMEACriticos(fmeas){ return fmeas.filter(f=>f.critico||f.npr>=100).length; }
function calcularDesviosMes(ncs) {
  const a=new Date();
  return ncs.filter(n=>{ try{const f=new Date(n.fechaHora||n.fechaCreacion||""); return f.getMonth()===a.getMonth()&&f.getFullYear()===a.getFullYear();} catch{return false;} }).length;
}
function calcularAccionesVencidas(ac) {
  const hoy=new Date(); hoy.setHours(0,0,0,0);
  return ac.filter(a=>a.estado!=="cerrada"&&a.fechaCompromiso&&new Date(a.fechaCompromiso)<hoy).length;
}
function calcularKPIsTPM(tpm) {
  const hoy=new Date(); hoy.setHours(0,0,0,0); const a=new Date();
  return {
    total:    tpm.length,
    pendientes: tpm.filter(t=>t.estado==="pendiente").length,
    vencidos: tpm.filter(t=>t.fechaProgramada&&new Date(t.fechaProgramada)<hoy&&t.estado!=="completado").length,
    correctivosMes: tpm.filter(t=>{ try{const f=new Date(t.fecha); return f.getMonth()===a.getMonth()&&f.getFullYear()===a.getFullYear()&&t.tipo==="correctivo";} catch{return false;} }).length,
    completadosMes: tpm.filter(t=>{ try{const f=new Date(t.fechaCompletado||""); return f.getMonth()===a.getMonth()&&f.getFullYear()===a.getFullYear();} catch{return false;} }).length,
  };
}
function exportarCSV(kpis, nivel, kpisTPM) {
  try {
    const datos=[
      ["KPI","Valor","Estado"],
      ["NC Abiertas",kpis.ncAbiertas,kpis.ncAbiertas<5?"OK":"Alerta"],
      ["FMEA Críticos",kpis.fmeaCriticos,kpis.fmeaCriticos===0?"OK":"Crítico"],
      ["Desvíos del mes",kpis.desviosMes,"—"],
      ["Acciones vencidas",kpis.accionesVencidas,kpis.accionesVencidas===0?"OK":"Crítico"],
      ["TPM Pendientes",kpisTPM.pendientes,kpisTPM.pendientes===0?"OK":"Alerta"],
      ["TPM Vencidos",kpisTPM.vencidos,kpisTPM.vencidos===0?"OK":"Crítico"],
      ["Nivel CA",nivel.nivel,nivel.descripcion],
      ["Fecha",new Date().toLocaleString('es-AR'),"—"],
    ];
    const csv=datos.map(r=>r.map(c=>`"${c}"`).join(",")).join("\n");
    const blob=new Blob(["\uFEFF"+csv],{type:"text/csv;charset=utf-8;"});
    const a=document.createElement("a"); a.href=URL.createObjectURL(blob);
    a.download=`Dashboard_CA_${new Date().toISOString().slice(0,10)}.csv`; a.click();
  } catch(e){console.error(e);}
}

// ─── ANÁLISIS IA PARA DIRECCIÓN ───────────────────────────────
async function generarAnalisisIA(kpis, kpisTPM, nivel) {
  const prompt = `Sos ARIA, asistente de gestión integral de calidad de ALQOS™ by QORVEX.
Analizá los siguientes KPIs del sistema de gestión de una empresa industrial gráfica argentina y generá un informe ejecutivo para la Dirección.

DATOS ACTUALES DEL SISTEMA:
- Nivel CA: ${nivel.nivel} (${nivel.descripcion})
- NC Abiertas: ${kpis.ncAbiertas} (objetivo: < 5 para Oro)
- FMEA Críticos (NPR≥100): ${kpis.fmeaCriticos} (objetivo: 0)
- Desvíos del mes: ${kpis.desviosMes}
- Acciones Correctivas Vencidas: ${kpis.accionesVencidas} (objetivo: 0)
- Acciones eficaces verificadas: ${kpis.accionesEficaces}
- Scrap FSC del mes: ${kpis.scrapMes} kg
- NC automáticas generadas: ${kpis.ncAutomaticas}
- Plan de Control vinculado a FMEA: ${kpis.tienePCActivo ? "Sí" : "No"}
- Acciones vinculadas a NC: ${kpis.tieneAccionesVinculadas ? "Sí" : "No"}
- TPM Total órdenes: ${kpisTPM.total} | Pendientes: ${kpisTPM.pendientes} | Vencidas: ${kpisTPM.vencidos} | Correctivos este mes: ${kpisTPM.correctivosMes}
- Auditorías: ${kpis.auditoriasTotales} totales | ${kpis.auditoriasCompletadas} completadas | ${kpis.hallazgosMayores} NC mayores
- Documentos: ${kpis.docsTotales} totales | ${kpis.docsVencidos} vencidos | ${kpis.docsProximos} vencen en 30 días | ${kpis.docsSinPDF} sin PDF
- Análisis de Causa: ${kpis.analisisTotales} totales | ${kpis.analisisConCausaRaiz} con causa raíz identificada
- Programa Auditorías: ${kpis.programaTotales} planificadas | ${kpis.programaEjecutadas} ejecutadas | ${kpis.programaPendientes} pendientes
- OTs: ${kpis.otsTotales} totales | ${kpis.otsEnProceso} en curso | ${kpis.otsVencidas} con entrega vencida | ${kpis.otsRechazadas} rechazadas
- Materiales: ${kpis.ingresosTotales} ingresos | ${kpis.ingresosCuarentena} en cuarentena | ${kpis.ingresosDevueltos} devueltos | ${kpis.ingresosFSC} FSC
- Stock: ${kpis.palletsTotales} pallets | ${kpis.palletsDisponibles} disponibles | ${kpis.palletsAgotados} agotados
- Pre Prensa: ${kpis.planchasMes} planchas este mes | ${kpis.reimpresionesMes} reimpresiones | costo $${kpis.costoPlanchasMes}

FORMATO DE RESPUESTA (obligatorio, sin markdown, sin asteriscos):

INTERPRETACIÓN EJECUTIVA
[2-3 párrafos claros sobre el estado general del sistema. Indicá si hay riesgos críticos, si el nivel CA es sostenible y qué impacto tienen los KPIs en la calidad del producto y la certificación ISO.]

ALERTAS PRIORITARIAS
[Listá máximo 3 alertas específicas basadas en los datos. Cada alerta con: qué es, por qué es urgente, qué puede pasar si no se resuelve.]

ALTERNATIVAS DE DECISIÓN PARA DIRECCIÓN

OPCIÓN 1 — [nombre de la opción]
[Descripción de la acción. Recursos necesarios. Resultado esperado. Plazo sugerido.]

OPCIÓN 2 — [nombre de la opción]
[Descripción de la acción. Recursos necesarios. Resultado esperado. Plazo sugerido.]

OPCIÓN 3 — [nombre de la opción]
[Descripción de la acción. Recursos necesarios. Resultado esperado. Plazo sugerido.]

CONCLUSIÓN
[1 párrafo con la recomendación más urgente para mantener o mejorar el nivel CA actual.]`;

  const response = await fetch("/api/aria", {
    method:"POST",
    headers:{ ...(await authHeader()),
  "Content-Type":"application/json",
  "anthropic-version": "2023-06-01",
  },
    body: JSON.stringify({
      model:"claude-sonnet-4-5",
      max_tokens:1500,
      messages:[{role:"user", content:prompt}]
    })
  });
  const data = await response.json();
  return data.content?.[0]?.text || "No se pudo generar el análisis. Verificá la conexión con ARIA.";
}

export default function DashboardCA({ onVolver, oscuro, usuario, navegarA }) {
  const [datos,     setDatos]     = useState(() => leerDatos());
  const [ultimaAct, setUltimaAct] = useState(new Date());
  const [analisisIA,  setAnalisisIA]  = useState("");
  const [cargandoIA,  setCargandoIA]  = useState(false);
  const [mostrarIA,   setMostrarIA]   = useState(false);
  const [errorIA,     setErrorIA]     = useState("");
  const [mostrarSim,  setMostrarSim]  = useState(false);
  const [escSel,       setEscSel]      = useState("paros");
  const [invInicial,   setInvInicial]  = useState("");
  const [costoMensual, setCostoMensual]= useState("");
  const [reduccion,    setReduccion]   = useState(30);

  const bg      = oscuro ? "#09184D" : Q.grisPalido;
  const cardBg  = oscuro ? "#0d2160" : Q.blanco;
  const texto   = oscuro ? "#EDF2FA" : Q.grisOscuro;
  const borde   = oscuro ? "#1e3a8a" : Q.grisClaro;
  const navBg   = oscuro ? "#060f30" : Q.azul;
  const subtexto= oscuro ? "#9aabd4" : Q.grisPlata;
  const card    = {background:cardBg, borderRadius:"14px", padding:"1.5rem", border:`1px solid ${borde}`, marginBottom:"14px"};

  const esDireccion = ["Administrador","Dirección"].includes(usuario?.rol);

  useEffect(() => {
    const interval = setInterval(() => { setDatos(leerDatos()); setUltimaAct(new Date()); }, 30000);
    return () => clearInterval(interval);
  }, []);

  const refrescar = () => { setDatos(leerDatos()); setUltimaAct(new Date()); };

  const kpis = useMemo(() => {
    const ncAbiertas         = calcularNCAbiertas(datos.ncs);
    const fmeaCriticos       = calcularFMEACriticos(datos.fmeas);
    const desviosMes         = calcularDesviosMes(datos.ncs);
    const accionesVencidas   = calcularAccionesVencidas(datos.acciones);
    const totalRegistros     = datos.fmeas.length+datos.ncs.length+datos.planControl.length+datos.acciones.length;
    const tieneAccionesVinculadas = datos.acciones.some(a=>a.idNC);
    const tienePCActivo      = datos.planControl.some(p=>p.idFMEARelacionado);
    const scrapMes           = datos.fsc.filter(m=>{ try{const f=new Date(m.fecha); const a=new Date(); return f.getMonth()===a.getMonth()&&f.getFullYear()===a.getFullYear()&&m.kgScrap>0;} catch{return false;} }).reduce((acc,m)=>acc+(Number(m.kgScrap)||0),0);
    return {
      ncAbiertas, fmeaCriticos, desviosMes, accionesVencidas,
      totalNC:datos.ncs.length, totalFMEA:datos.fmeas.length,
      totalAcciones:datos.acciones.length, totalPC:datos.planControl.length,
      totalRegistros, tieneAccionesVinculadas, tienePCActivo,
      scrapMes: Math.round(scrapMes*100)/100,
      ncAutomaticas: datos.ncs.filter(n=>n.generadaAutomaticamente).length,
      accionesEficaces: datos.acciones.filter(a=>a.resultadoEficacia==="eficaz").length,
      // Auditorias
      auditoriasTotales: datos.auditorias.length,
      auditoriasCompletadas: datos.auditorias.filter(a=>a.estado==="completada").length,
      auditoriasEnCurso: datos.auditorias.filter(a=>a.estado==="en_curso").length,
      hallazgosTotales: datos.auditorias.reduce((acc,a)=>acc+(a.hallazgos?.length||0),0),
      hallazgosMayores: datos.auditorias.reduce((acc,a)=>acc+(a.hallazgos?.filter(h=>h.tipo==="nc_mayor").length||0),0),
      // Documentos
      docsTotales: datos.docs.length,
      docsVigentes: datos.docs.filter(d=>d.estado==="vigente").length,
      docsVencidos: datos.docs.filter(d=>{ if(!d.fechaVencimiento||d.estado==="obsoleto") return false; return new Date(d.fechaVencimiento)<new Date(); }).length,
      docsProximos: datos.docs.filter(d=>{ if(!d.fechaVencimiento||d.estado==="obsoleto") return false; const dias=Math.ceil((new Date(d.fechaVencimiento)-new Date())/(1000*60*60*24)); return dias>=0&&dias<=30; }).length,
      docsSinPDF: datos.docs.filter(d=>d.estado==="vigente"&&!d.pdfUrl).length,
      // Analisis Causa
      analisisTotales: datos.analisisCausa.length,
      analisisConCausaRaiz: datos.analisisCausa.filter(a=>a.causaRaizFinal).length,
      // Programa auditorias
      programaTotales: datos.programa.length,
      programaEjecutadas: datos.programa.filter(p=>p.estado==="ejecutada").length,
      programaPendientes: datos.programa.filter(p=>p.estado==="pendiente").length,
      // OTs
      otsTotales:    datos.ots.length,
      otsEnProceso:  datos.ots.filter(o=>["pendiente","en_proceso","control_calidad"].includes(o.estado)).length,
      otsEntregadas: datos.ots.filter(o=>o.estado==="entregado").length,
      otsRechazadas: datos.ots.filter(o=>o.estado==="rechazado").length,
      otsVencidas:   datos.ots.filter(o=>o.fechaEntrega&&new Date(o.fechaEntrega)<new Date()&&!["entregado","rechazado"].includes(o.estado)).length,
      // Materiales
      ingresosTotales:    datos.ingresos.length,
      ingresosCuarentena: datos.ingresos.filter(i=>i.estado==="cuarentena").length,
      ingresosDevueltos:  datos.ingresos.filter(i=>i.estado==="devuelto").length,
      ingresosFSC:        datos.ingresos.filter(i=>i.esFSC).length,
      // Stock pallets
      palletsTotales:     datos.pallets.length,
      palletsDisponibles: datos.pallets.filter(p=>p.estado==="disponible").length,
      palletsEnUso:       datos.pallets.filter(p=>p.estado==="en_uso").length,
      palletsAgotados:    datos.pallets.filter(p=>p.estado==="agotado").length,
      // Planchas del mes
      planchasMes:        datos.planchas.filter(p=>p.fecha?.startsWith(new Date().toISOString().slice(0,7))).length,
      reimpresionesMes:   datos.planchas.filter(p=>p.fecha?.startsWith(new Date().toISOString().slice(0,7))&&!p.esPrimera).length,
      costoPlanchasMes:   Math.round(datos.planchas.filter(p=>p.fecha?.startsWith(new Date().toISOString().slice(0,7))).reduce((s,p)=>s+parseFloat(p.costo||0),0)*100)/100,
    };
  }, [datos]);

  const kpisTPM = useMemo(() => calcularKPIsTPM(datos.tpm), [datos]);
  const nivel   = useMemo(() => calcularNivelCA({...kpis, tpmVencidos:kpisTPM.vencidos, auditoriasEjecutadas:kpis.programaEjecutadas}), [kpis, kpisTPM]);
  const semaforo= (v,lv,la) => v<=lv?"#22c55e":v<=la?"#f59e0b":"#e63946";

  const handleAnalisisIA = async () => {
    if (!esDireccion) return;
    setMostrarIA(true);
    if (analisisIA) return; // ya generado
    setCargandoIA(true);
    setErrorIA("");
    try {
      const texto = await generarAnalisisIA(kpis, kpisTPM, nivel);
      setAnalisisIA(texto);
    } catch(e) {
      setErrorIA("No se pudo conectar con ARIA. Verificá que la API key esté configurada en Vercel.");
    }
    setCargandoIA(false);
  };

  const regenerarAnalisis = async () => {
    setAnalisisIA("");
    setCargandoIA(true);
    setErrorIA("");
    try {
      const t = await generarAnalisisIA(kpis, kpisTPM, nivel);
      setAnalisisIA(t);
    } catch(e) {
      setErrorIA("Error de conexión con ARIA.");
    }
    setCargandoIA(false);
  };

  // Formatear el análisis en secciones visuales
  const formatearAnalisis = (texto) => {
    if (!texto) return null;
    const secciones = [];
    const lineas = texto.split('\n');
    let seccionActual = null;
    let contenidoActual = [];

    const coloresSecciones = {
      "INTERPRETACIÓN EJECUTIVA": { color:"#1C3FAA", bg: oscuro?"#0a1f5c":"#eff6ff", borde:Q.azulVivo },
      "ALERTAS PRIORITARIAS":     { color:"#dc2626", bg: oscuro?"#1a0505":"#fff5f5", borde:"#e63946" },
      "ALTERNATIVAS DE DECISIÓN PARA DIRECCIÓN": { color:"#16a34a", bg: oscuro?"#0a1f0a":"#f0fdf4", borde:"#22c55e" },
      "CONCLUSIÓN":               { color:"#d97706", bg: oscuro?"#1a1000":"#fffbeb", borde:"#f59e0b" },
    };

    for (const linea of lineas) {
      const tituloSec = Object.keys(coloresSecciones).find(k => linea.trim().startsWith(k));
      if (tituloSec) {
        if (seccionActual) secciones.push({ titulo:seccionActual, contenido:contenidoActual.join('\n'), ...coloresSecciones[seccionActual] });
        seccionActual = tituloSec;
        contenidoActual = [];
      } else if (seccionActual) {
        contenidoActual.push(linea);
      }
    }
    if (seccionActual) secciones.push({ titulo:seccionActual, contenido:contenidoActual.join('\n'), ...coloresSecciones[seccionActual] });

    return secciones.map((s,i) => (
      <div key={i} style={{ background:s.bg, borderRadius:"12px", padding:"1.2rem 1.5rem", marginBottom:"10px", border:`1.5px solid ${s.borde}40`, borderLeft:`4px solid ${s.borde}` }}>
        <p style={{ fontSize:"11px", fontWeight:"800", color:s.color, letterSpacing:".15em", textTransform:"uppercase", margin:"0 0 10px" }}>{s.titulo}</p>
        {s.contenido.split('\n').filter(l=>l.trim()).map((l,j) => {
          const esOpcion = l.trim().startsWith("OPCIÓN");
          return (
            <p key={j} style={{ fontSize:"13px", color:esOpcion?(oscuro?"white":Q.grisOscuro):texto, lineHeight:"1.7", margin:"0 0 6px", fontWeight:esOpcion?"700":"400" }}>
              {l.trim()}
            </p>
          );
        })}
      </div>
    ));
  };

  return (
    <div style={{ minHeight:"100vh", background:bg, fontFamily:"sans-serif" }}>

      {/* NAVBAR */}
      <div style={{ background:navBg, padding:"1rem 1.5rem", display:"flex", alignItems:"center", justifyContent:"space-between", position:"sticky", top:0, zIndex:100, boxShadow:`0 2px 16px ${Q.azul}50` }}>
        <div style={{ display:"flex", alignItems:"center", gap:"12px" }}>
          <button onClick={onVolver} style={{ background:"rgba(255,255,255,0.1)", border:"none", color:"white", padding:"6px 14px", borderRadius:"10px", cursor:"pointer", fontSize:"13px" }}>← Menú</button>
          <span style={{ color:"white", fontWeight:"700", fontSize:"16px" }}>🏅 Dashboard CA</span>
        </div>
        <div style={{ display:"flex", gap:"8px" }}>
          {esDireccion && (
            <button onClick={handleAnalisisIA}
              style={{ padding:"6px 12px", background:mostrarIA?Q.azulVivo:"rgba(255,255,255,0.12)", border:`1px solid ${mostrarIA?Q.azulVivo:"rgba(255,255,255,0.2)"}`, borderRadius:"8px", cursor:"pointer", fontSize:"12px", color:"white", fontWeight:"600" }}>
              🤖 {mostrarIA?"Análisis IA activo":"Análisis IA para Dirección"}
            </button>
          )}
          <button onClick={refrescar} style={{ padding:"6px 10px", background:"rgba(255,255,255,0.1)", border:"none", borderRadius:"8px", cursor:"pointer", fontSize:"12px", color:"white" }}>🔄</button>
          <button onClick={() => exportarCSV(kpis, nivel, kpisTPM)} style={{ padding:"6px 10px", background:"rgba(255,255,255,0.1)", border:"none", borderRadius:"8px", cursor:"pointer", fontSize:"12px", color:"white" }}>📊</button>
          {usuario?.rol === "Administrador" && <BotonMapaProceso moduloKey="dashboard_ca" oscuro={oscuro} />}
        </div>
      </div>

      <div style={{ padding:"1rem 1.5rem", maxWidth:"840px", margin:"0 auto" }}>

        {/* NIVEL CA */}
        <div style={{ background:nivel.colorBg, borderRadius:"20px", padding:"2rem", border:`2px solid ${nivel.color}`, marginBottom:"1.5rem", textAlign:"center" }}>
          <p style={{ fontSize:"52px", margin:"0 0 8px" }}>{nivel.icono}</p>
          <h2 style={{ fontSize:"30px", fontWeight:"800", color:nivel.color, margin:"0 0 8px" }}>Nivel {nivel.nivel}</h2>
          <p style={{ fontSize:"14px", color:subtexto, margin:"0 0 16px" }}>{nivel.descripcion}</p>
          <div style={{ display:"flex", justifyContent:"center", gap:"8px", flexWrap:"wrap" }}>
            {[["Bronce","🥉","#cd7f32"],["Plata","🥈","#6b7280"],["Oro","🥇","#f59e0b"]].map(([n,ico,col])=>(
              <div key={n} style={{ padding:"6px 16px", borderRadius:"20px", fontSize:"12px", fontWeight:"600", background:nivel.nivel===n?`${col}22`:"transparent", border:`2px solid ${nivel.nivel===n?col:"#ddd"}`, color:nivel.nivel===n?col:"#ccc" }}>{ico} {n}</div>
            ))}
          </div>
          <p style={{ fontSize:"11px", color:subtexto, marginTop:"10px" }}>Actualización automática cada 30s · Última: {ultimaAct.toLocaleTimeString('es-AR')}</p>
        </div>

        {/* ── ANÁLISIS IA PARA DIRECCIÓN ──────────────────────────── */}
        {esDireccion && mostrarIA && (
          <div style={{ ...card, background: oscuro?"#050e2e":"#f8faff", border:`2px solid ${Q.azulVivo}40` }}>
            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:"16px" }}>
              <div>
                <h3 style={{ fontSize:"15px", fontWeight:"800", color:Q.azul, margin:"0 0 2px" }}>🤖 Análisis Ejecutivo IA — ARIA</h3>
                <p style={{ fontSize:"11px", color:subtexto, margin:0 }}>Generado con datos reales del sistema · Exclusivo Dirección y Administrador</p>
              </div>
              <div style={{ display:"flex", gap:"6px" }}>
                {analisisIA && (
                  <button onClick={regenerarAnalisis} style={{ padding:"5px 10px", background:"rgba(42,127,255,0.1)", border:`1px solid ${Q.azulVivo}40`, borderRadius:"8px", cursor:"pointer", fontSize:"11px", color:Q.azulVivo, fontWeight:"600" }}>
                    🔄 Regenerar
                  </button>
                )}
                <button onClick={() => setMostrarIA(false)} style={{ padding:"5px 10px", background:"none", border:`1px solid ${borde}`, borderRadius:"8px", cursor:"pointer", fontSize:"11px", color:subtexto }}>
                  Cerrar
                </button>
              </div>
            </div>

            {cargandoIA && (
              <div style={{ textAlign:"center", padding:"3rem" }}>
                <div style={{ display:"flex", justifyContent:"center", gap:"6px", marginBottom:"12px" }}>
                  {[0,1,2].map(i => (
                    <div key={i} style={{ width:"10px", height:"10px", borderRadius:"50%", background:Q.azulVivo, animation:"rotateHex 1s ease-in-out infinite", animationDelay:`${i*0.2}s` }}/>
                  ))}
                </div>
                <p style={{ fontSize:"13px", color:subtexto }}>ARIA está analizando los KPIs del sistema...</p>
                <p style={{ fontSize:"11px", color:subtexto, marginTop:"4px" }}>Esto puede tomar unos segundos</p>
              </div>
            )}

            {errorIA && (
              <div style={{ background:"#fff5f5", border:"1.5px solid #e63946", borderRadius:"10px", padding:"14px", marginBottom:"10px" }}>
                <p style={{ fontSize:"13px", color:"#e63946", fontWeight:"600", margin:"0 0 4px" }}>⚠️ Error al conectar con ARIA</p>
                <p style={{ fontSize:"12px", color:"#e63946", margin:0 }}>{errorIA}</p>
                <p style={{ fontSize:"11px", color:subtexto, marginTop:"8px", margin:"8px 0 0" }}>
                  Para activar ARIA: Vercel → Settings → Environment Variables → agregar ANTHROPIC_KEY con tu API key de Anthropic (variable de servidor, sin prefijo REACT_APP_).
                </p>
              </div>
            )}

            {analisisIA && !cargandoIA && (
              <div>
                {formatearAnalisis(analisisIA)}
                <p style={{ fontSize:"10px", color:subtexto, textAlign:"center", marginTop:"8px" }}>
                  Generado por ARIA · {new Date().toLocaleString('es-AR')} · Basado en datos reales del sistema ALQOS™
                </p>
              </div>
            )}
          </div>
        )}

        {/* Si es Dirección y no tiene IA activa, mostrar prompt */}
        {esDireccion && !mostrarIA && (
          <div style={{ background: oscuro?"#0a1f3c":"#eff6ff", borderRadius:"14px", padding:"1.2rem 1.5rem", border:`1.5px solid ${Q.azulVivo}30`, marginBottom:"14px", display:"flex", justifyContent:"space-between", alignItems:"center" }}>
            <div>
              <p style={{ fontSize:"13px", fontWeight:"700", color:Q.azul, margin:"0 0 2px" }}>🤖 Análisis Ejecutivo con IA disponible</p>
              <p style={{ fontSize:"12px", color:subtexto, margin:0 }}>ARIA interpreta los KPIs y genera alternativas de decisión para la Dirección</p>
            </div>
            <button onClick={handleAnalisisIA} style={{ padding:"8px 16px", background:`linear-gradient(135deg,${Q.azulVivo},${Q.azul})`, border:"none", borderRadius:"10px", cursor:"pointer", color:"white", fontSize:"12px", fontWeight:"700", flexShrink:0, boxShadow:`0 4px 14px ${Q.azulVivo}40` }}>
              Ver análisis IA
            </button>
          </div>
        )}

        {/* KPIs CALIDAD */}
        <p style={{ fontSize:"10px", fontWeight:"700", color:subtexto, letterSpacing:".2em", textTransform:"uppercase", marginBottom:"10px", display:"flex", alignItems:"center", gap:"8px" }}>
          <span style={{ display:"inline-block", width:"20px", height:"2px", background:Q.azulVivo, borderRadius:"2px" }}/>
          Calidad e ISO 9001
        </p>
        <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill, minmax(145px,1fr))", gap:"10px", marginBottom:"1.5rem" }}>
          {[
            {label:"NC Abiertas",     val:kpis.ncAbiertas,        color:semaforo(kpis.ncAbiertas,4,9),            icono:"⚠️",  desc:"Objetivo: < 5"},
            {label:"FMEA Críticos",   val:kpis.fmeaCriticos,      color:semaforo(kpis.fmeaCriticos,0,2),          icono:"🔍",  desc:"NPR ≥ 100"},
            {label:"Desvíos del mes", val:kpis.desviosMes,        color:semaforo(kpis.desviosMes,3,7),            icono:"📉",  desc:"Mes actual"},
            {label:"Acc. vencidas",   val:kpis.accionesVencidas,  color:semaforo(kpis.accionesVencidas,0,2),      icono:"⏰",  desc:"Sin cerrar"},
            {label:"Scrap FSC mes",   val:`${kpis.scrapMes}kg`,   color:semaforo(kpis.scrapMes,0,50),             icono:"🌿",  desc:"Material descartado"},
            {label:"Acc. eficaces",   val:kpis.accionesEficaces,  color:"#22c55e",                                icono:"✅",  desc:"Verificadas"},
          ].map(({label,val,color,icono,desc})=>(
            <div key={label} style={{ background:cardBg, borderRadius:"14px", padding:"1.2rem", border:`1px solid ${borde}`, textAlign:"center", boxShadow:`0 2px 8px ${color}15` }}>
              <p style={{ fontSize:"22px", margin:"0 0 6px" }}>{icono}</p>
              <p style={{ fontSize:"22px", fontWeight:"800", color, margin:"0 0 4px" }}>{val}</p>
              <p style={{ fontSize:"11px", fontWeight:"600", color:texto, margin:"0 0 2px" }}>{label}</p>
              <p style={{ fontSize:"10px", color:subtexto, margin:0 }}>{desc}</p>
            </div>
          ))}
        </div>

        {/* KPIs TPM */}
        <p style={{ fontSize:"10px", fontWeight:"700", color:subtexto, letterSpacing:".2em", textTransform:"uppercase", marginBottom:"10px", display:"flex", alignItems:"center", gap:"8px" }}>
          <span style={{ display:"inline-block", width:"20px", height:"2px", background:Q.azulVivo, borderRadius:"2px" }}/>
          TPM — Mantenimiento Productivo Total
        </p>
        <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill, minmax(145px,1fr))", gap:"10px", marginBottom:"1.5rem" }}>
          {[
            {label:"Total órdenes",    val:kpisTPM.total,           color:"#22c55e",                          icono:"🔧",  desc:"Historial completo"},
            {label:"Pendientes",       val:kpisTPM.pendientes,      color:semaforo(kpisTPM.pendientes,2,5),   icono:"⏳",  desc:"Sin completar"},
            {label:"Vencidos",         val:kpisTPM.vencidos,        color:semaforo(kpisTPM.vencidos,0,1),     icono:"🔴",  desc:"Fuera de fecha"},
            {label:"Correctivos mes",  val:kpisTPM.correctivosMes,  color:semaforo(kpisTPM.correctivosMes,2,5),icono:"🛠️", desc:"Fallas este mes"},
            {label:"Completados mes",  val:kpisTPM.completadosMes,  color:"#22c55e",                          icono:"✅",  desc:"Finalizados"},
          ].map(({label,val,color,icono,desc})=>(
            <div key={label} style={{ background:cardBg, borderRadius:"14px", padding:"1.2rem", border:`1px solid ${borde}`, textAlign:"center", boxShadow:`0 2px 8px ${color}15` }}>
              <p style={{ fontSize:"22px", margin:"0 0 6px" }}>{icono}</p>
              <p style={{ fontSize:"22px", fontWeight:"800", color, margin:"0 0 4px" }}>{val}</p>
              <p style={{ fontSize:"11px", fontWeight:"600", color:texto, margin:"0 0 2px" }}>{label}</p>
              <p style={{ fontSize:"10px", color:subtexto, margin:0 }}>{desc}</p>
            </div>
          ))}
        </div>


        {/* KPIs AUDITORIAS */}
        <p style={{ fontSize:"10px", fontWeight:"700", color:subtexto, letterSpacing:".2em", textTransform:"uppercase", marginBottom:"10px", display:"flex", alignItems:"center", gap:"8px" }}>
          <span style={{ display:"inline-block", width:"20px", height:"2px", background:Q.azulVivo, borderRadius:"2px" }}/>
          Auditorías ISO
        </p>
        <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill, minmax(145px,1fr))", gap:"10px", marginBottom:"1.5rem" }}>
          {[
            {label:"Total auditorías",    val:kpis.auditoriasTotales,    color:"#7B5BF2",                                          icono:"🔎", desc:"Historial completo"},
            {label:"Completadas",         val:kpis.auditoriasCompletadas,color:"#22c55e",                                          icono:"✅", desc:"Finalizadas"},
            {label:"En curso",            val:kpis.auditoriasEnCurso,    color:semaforo(kpis.auditoriasEnCurso,1,3),               icono:"🔵", desc:"En progreso"},
            {label:"Hallazgos totales",   val:kpis.hallazgosTotales,     color:semaforo(kpis.hallazgosTotales,3,8),                icono:"📋", desc:"Todos los hallazgos"},
            {label:"NC Mayores",          val:kpis.hallazgosMayores,     color:semaforo(kpis.hallazgosMayores,0,2),                icono:"🔴", desc:"Hallazgos críticos"},
            {label:"Prog. pendientes",    val:kpis.programaPendientes,   color:semaforo(kpis.programaPendientes,2,5),              icono:"📅", desc:"Sin ejecutar"},
          ].map(({label,val,color,icono,desc})=>(
            <div key={label} style={{ background:cardBg, borderRadius:"14px", padding:"1.2rem", border:`1px solid ${borde}`, textAlign:"center", boxShadow:`0 2px 8px ${color}15` }}>
              <p style={{ fontSize:"22px", margin:"0 0 6px" }}>{icono}</p>
              <p style={{ fontSize:"22px", fontWeight:"800", color, margin:"0 0 4px" }}>{val}</p>
              <p style={{ fontSize:"11px", fontWeight:"600", color:texto, margin:"0 0 2px" }}>{label}</p>
              <p style={{ fontSize:"10px", color:subtexto, margin:0 }}>{desc}</p>
            </div>
          ))}
        </div>

        {/* KPIs DOCUMENTOS */}
        <p style={{ fontSize:"10px", fontWeight:"700", color:subtexto, letterSpacing:".2em", textTransform:"uppercase", marginBottom:"10px", display:"flex", alignItems:"center", gap:"8px" }}>
          <span style={{ display:"inline-block", width:"20px", height:"2px", background:Q.azulVivo, borderRadius:"2px" }}/>
          Documentos ISO §7.5
        </p>
        <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill, minmax(145px,1fr))", gap:"10px", marginBottom:"1.5rem" }}>
          {[
            {label:"Total docs",          val:kpis.docsTotales,          color:"#7B5BF2",                                          icono:"📁", desc:"En el sistema"},
            {label:"Vigentes",            val:kpis.docsVigentes,         color:"#22c55e",                                          icono:"✅", desc:"Estado vigente"},
            {label:"Vencidos",            val:kpis.docsVencidos,         color:semaforo(kpis.docsVencidos,0,2),                    icono:"🔴", desc:"Requieren revisión"},
            {label:"Vencen en 30d",       val:kpis.docsProximos,         color:semaforo(kpis.docsProximos,0,3),                    icono:"⏰", desc:"Próximos a vencer"},
            {label:"Sin PDF",             val:kpis.docsSinPDF,           color:semaforo(kpis.docsSinPDF,5,15),                     icono:"📄", desc:"Vigentes sin archivo"},
            {label:"Análisis causa",      val:kpis.analisisTotales,      color:"#7B5BF2",                                          icono:"🔬", desc:"Registrados"},
          ].map(({label,val,color,icono,desc})=>(
            <div key={label} style={{ background:cardBg, borderRadius:"14px", padding:"1.2rem", border:`1px solid ${borde}`, textAlign:"center", boxShadow:`0 2px 8px ${color}15` }}>
              <p style={{ fontSize:"22px", margin:"0 0 6px" }}>{icono}</p>
              <p style={{ fontSize:"22px", fontWeight:"800", color, margin:"0 0 4px" }}>{val}</p>
              <p style={{ fontSize:"11px", fontWeight:"600", color:texto, margin:"0 0 2px" }}>{label}</p>
              <p style={{ fontSize:"10px", color:subtexto, margin:0 }}>{desc}</p>
            </div>
          ))}
        </div>
        {/* KPIs OPERACIONES */}
        <p style={{ fontSize:"10px", fontWeight:"700", color:subtexto, letterSpacing:".2em", textTransform:"uppercase", marginBottom:"10px", display:"flex", alignItems:"center", gap:"8px" }}>
          <span style={{ display:"inline-block", width:"20px", height:"2px", background:Q.azulVivo, borderRadius:"2px" }}/>
          Operaciones — OTs · Materiales · Stock
        </p>
        <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill, minmax(145px,1fr))", gap:"10px", marginBottom:"1.5rem" }}>
          {[
            {label:"OTs en curso",       val:kpis.otsEnProceso,      color:semaforo(kpis.otsEnProceso,5,15),        icono:"📋", desc:"Pendientes + proceso"},
            {label:"OTs vencidas",       val:kpis.otsVencidas,       color:semaforo(kpis.otsVencidas,0,2),          icono:"⏰", desc:"Fecha entrega pasada"},
            {label:"Mat. cuarentena",    val:kpis.ingresosCuarentena,color:semaforo(kpis.ingresosCuarentena,0,2),   icono:"⏳", desc:"Pendientes de decisión"},
            {label:"Pallets disponibles",val:kpis.palletsDisponibles, color:"#22c55e",                              icono:"📦", desc:"Stock listo para usar"},
            {label:"Reimpr. planchas",   val:kpis.reimpresionesMes,  color:semaforo(kpis.reimpresionesMes,2,5),     icono:"🖨️", desc:"Este mes"},
            {label:"Costo planchas",     val:`$${kpis.costoPlanchasMes}`,color:semaforo(kpis.costoPlanchasMes,0,5000),icono:"💰", desc:"Mes actual"},
          ].map(({label,val,color,icono,desc})=>(
            <div key={label} style={{ background:cardBg, borderRadius:"14px", padding:"1.2rem", border:`1px solid ${borde}`, textAlign:"center", boxShadow:`0 2px 8px ${color}15` }}>
              <p style={{ fontSize:"22px", margin:"0 0 6px" }}>{icono}</p>
              <p style={{ fontSize:"22px", fontWeight:"800", color, margin:"0 0 4px" }}>{val}</p>
              <p style={{ fontSize:"11px", fontWeight:"600", color:texto, margin:"0 0 2px" }}>{label}</p>
              <p style={{ fontSize:"10px", color:subtexto, margin:0 }}>{desc}</p>
            </div>
          ))}
        </div>

        {/* SEMÁFORO ORO */}
        <div style={card}>
          <h3 style={{ fontSize:"13px", fontWeight:"700", color:texto, marginBottom:"14px", letterSpacing:".05em", textTransform:"uppercase" }}>Condiciones para nivel Oro 🥇</h3>
          {[
            {label:"NC abiertas < 5",                    ok:kpis.ncAbiertas<5,            actual:`Actual: ${kpis.ncAbiertas}`},
            {label:"Sin acciones vencidas",              ok:kpis.accionesVencidas===0,     actual:`Vencidas: ${kpis.accionesVencidas}`},
            {label:"Sin FMEA críticos (NPR≥100)",        ok:kpis.fmeaCriticos===0,         actual:`Críticos: ${kpis.fmeaCriticos}`},
            {label:"Plan de Control vinculado a FMEA",   ok:kpis.tienePCActivo,            actual:kpis.tienePCActivo?"✅ Configurado":"❌ Sin vincular"},
            {label:"Sin órdenes TPM vencidas",           ok:kpisTPM.vencidos===0,          actual:`Vencidas: ${kpisTPM.vencidos}`},
            {label:"Sin documentos vencidos",             ok:kpis.docsVencidos===0,         actual:`Vencidos: ${kpis.docsVencidos}`},
            {label:"Auditorías ejecutadas en programa",   ok:kpis.programaEjecutadas>0,     actual:kpis.programaEjecutadas>0?"✅ Ejecutadas":"❌ Sin ejecutar"},
            {label:"Sin OTs con entrega vencida",          ok:kpis.otsVencidas===0,          actual:`Vencidas: ${kpis.otsVencidas}`},
            {label:"Sin materiales en cuarentena",         ok:kpis.ingresosCuarentena===0,   actual:`En cuarentena: ${kpis.ingresosCuarentena}`},
          ].map(({label,ok,actual})=>(
            <div key={label} style={{ display:"flex", justifyContent:"space-between", alignItems:"center", padding:"8px 0", borderBottom:`0.5px solid ${borde}` }}>
              <div style={{ display:"flex", alignItems:"center", gap:"8px" }}>
                <span style={{ fontSize:"16px" }}>{ok?"✅":"🔴"}</span>
                <span style={{ fontSize:"13px", color:texto }}>{label}</span>
              </div>
              <span style={{ fontSize:"11px", color:ok?"#22c55e":"#e63946", fontWeight:"600" }}>{actual}</span>
            </div>
          ))}
        </div>

        {/* SEMÁFORO PLATA */}
        <div style={card}>
          <h3 style={{ fontSize:"13px", fontWeight:"700", color:texto, marginBottom:"14px", letterSpacing:".05em", textTransform:"uppercase" }}>Condiciones para nivel Plata 🥈</h3>
          {[
            {label:"NC abiertas < 10",                   ok:kpis.ncAbiertas<10,            actual:`Actual: ${kpis.ncAbiertas}`},
            {label:"Sin acciones vencidas",              ok:kpis.accionesVencidas===0,     actual:`Vencidas: ${kpis.accionesVencidas}`},
            {label:"Acción correctiva vinculada a NC",   ok:kpis.tieneAccionesVinculadas,  actual:kpis.tieneAccionesVinculadas?"✅ Configurado":"❌ Sin vincular"},
          ].map(({label,ok,actual})=>(
            <div key={label} style={{ display:"flex", justifyContent:"space-between", alignItems:"center", padding:"8px 0", borderBottom:`0.5px solid ${borde}` }}>
              <div style={{ display:"flex", alignItems:"center", gap:"8px" }}>
                <span style={{ fontSize:"16px" }}>{ok?"✅":"🔴"}</span>
                <span style={{ fontSize:"13px", color:texto }}>{label}</span>
              </div>
              <span style={{ fontSize:"11px", color:ok?"#22c55e":"#e63946", fontWeight:"600" }}>{actual}</span>
            </div>
          ))}
        </div>

        {/* TOTALES */}
        <div style={card}>
          <h3 style={{ fontSize:"13px", fontWeight:"700", color:texto, marginBottom:"14px", letterSpacing:".05em", textTransform:"uppercase" }}>Totales del sistema</h3>
          <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill, minmax(110px,1fr))", gap:"10px" }}>
            {[["Total NC",kpis.totalNC,"#e63946"],["Total FMEA",kpis.totalFMEA,"#f97316"],["Plan Control",kpis.totalPC,Q.azulMedio],["Acc. Correctivas",kpis.totalAcciones,Q.azulVivo],["NC automáticas",kpis.ncAutomaticas,"#22c55e"],["Órdenes TPM",kpisTPM.total,"#22c55e"],["Auditorías",kpis.auditoriasTotales,"#7B5BF2"],["Docs vigentes",kpis.docsVigentes,"#22c55e"],["Análisis Causa",kpis.analisisTotales,"#7B5BF2"],["OTs totales",kpis.otsTotales,"#3b82f6"],["Stock pallets",kpis.palletsTotales,"#22c55e"]].map(([lab,val,col])=>(
              <div key={lab} style={{ background: oscuro?"#091840":Q.grisPalido, borderRadius:"10px", padding:"10px", textAlign:"center", border:`1px solid ${borde}` }}>
                <p style={{ fontSize:"20px", fontWeight:"800", color:col, margin:0 }}>{val}</p>
                <p style={{ fontSize:"10px", color:subtexto, margin:"3px 0 0" }}>{lab}</p>
              </div>
            ))}
          </div>
        </div>

        {/* ISO */}
        <div style={{ ...card, background: oscuro?"#0a1f5c":"#eff6ff", border:`1px solid ${oscuro?"#1e3a8a":"#bde0fe"}` }}>
          <h3 style={{ fontSize:"13px", fontWeight:"700", color:Q.azulVivo, marginBottom:"12px", letterSpacing:".05em", textTransform:"uppercase" }}>Cláusulas ISO 9001:2015 cubiertas</h3>
          {[
            {clausula:"6.1",  desc:"Acciones para abordar riesgos",         ok:kpis.totalFMEA>0},
            {clausula:"8.5.6",desc:"Control de cambios (Plan de Control)",  ok:kpis.totalPC>0},
            {clausula:"9.1",  desc:"Seguimiento, medición y análisis",      ok:kpis.totalNC>0},
            {clausula:"10.2", desc:"No conformidad y acción correctiva",    ok:kpis.totalAcciones>0},
            {clausula:"7.5",  desc:"Control de información documentada",    ok:kpis.docsTotales>0},
            {clausula:"9.2",  desc:"Auditoría interna",                     ok:kpis.auditoriasTotales>0},
            {clausula:"8.7",  desc:"Control de productos no conformes",     ok:kpis.totalNC>0},
            {clausula:"10.3", desc:"Mejora continua",                       ok:kpis.analisisTotales>0},
          ].map(({clausula,desc,ok})=>(
            <div key={clausula} style={{ display:"flex", justifyContent:"space-between", alignItems:"center", padding:"7px 0", borderBottom:`0.5px solid ${borde}` }}>
              <div style={{ display:"flex", alignItems:"center", gap:"10px" }}>
                <span style={{ fontSize:"11px", fontWeight:"700", color:Q.azulVivo, background:"#dbeafe", padding:"2px 6px", borderRadius:"6px" }}>§ {clausula}</span>
                <span style={{ fontSize:"12px", color:texto }}>{desc}</span>
              </div>
              <span style={{ fontSize:"14px" }}>{ok?"✅":"⬜"}</span>
            </div>
          ))}
        </div>

        {/* CARD CNC */}
        {(() => {
          const cnc = calcularResumenCNC();
          return (
            <div style={{ background: cnc.configurado ? (oscuro?"#0a1f0a":"#f0fdf4") : (oscuro?"#1a1000":"#fffbeb"), borderRadius:"14px", padding:"1.2rem 1.5rem", border:`1.5px solid ${cnc.configurado?"#16a34a40":"#d9780640"}`, marginBottom:"14px", display:"flex", justifyContent:"space-between", alignItems:"center" }}>
              <div>
                <p style={{ fontSize:"13px", fontWeight:"700", color: cnc.configurado?"#16a34a":"#d97706", margin:"0 0 4px" }}>💸 Costos de No Calidad — Mes actual</p>
                {cnc.configurado ? (<>
                  <p style={{ fontSize:"24px", fontWeight:"800", color:"#16a34a", margin:"0 0 2px" }}>${Math.round(cnc.total).toLocaleString('es-AR')}</p>
                  {cnc.totalUSD > 0 && <p style={{ fontSize:"12px", color:subtexto, margin:"0 0 4px" }}>USD {Math.round(cnc.totalUSD).toLocaleString('es-AR')}</p>}
                  <div style={{ display:"flex", gap:"8px", flexWrap:"wrap" }}>
                    <span style={{ fontSize:"10px", background:"#fee2e2", color:"#dc2626", padding:"2px 7px", borderRadius:"5px" }}>{cnc.ncsMes} NCs</span>
                    <span style={{ fontSize:"10px", background:"#fee2e2", color:"#dc2626", padding:"2px 7px", borderRadius:"5px" }}>{cnc.scrapMes}kg scrap</span>
                    <span style={{ fontSize:"10px", background:"#fee2e2", color:"#dc2626", padding:"2px 7px", borderRadius:"5px" }}>{cnc.paros} paros</span>
                  </div>
                </>) : (
                  <p style={{ fontSize:"12px", color:subtexto, margin:0 }}>Configurá los costos para ver el impacto económico de la no calidad</p>
                )}
              </div>
              <button onClick={() => navegarA && navegarA('costosnocal')}
                style={{ background: cnc.configurado?"#16a34a":"#d97706", color:"white", border:"none", borderRadius:"10px", padding:"8px 16px", fontSize:"12px", fontWeight:"600", cursor:"pointer", flexShrink:0, marginLeft:"16px" }}>
                {cnc.configurado ? "Ver detalle →" : "Configurar →"}
              </button>
            </div>
          );
        })()}

        {esDireccion && (() => {
          const cnc = calcularResumenCNC();
          const ESCENARIOS = {
            paros:   { nombre:"🔧 Mantenimiento predictivo (TPM)",   desc:"Reduce paros correctivos no planificados",        driver:cnc.costoParos,    unidad:`${cnc.paros} paros/mes` },
            calidad: { nombre:"⚠️ Reducir NC / Reproceso",           desc:"Capacitación, control adicional, mejora de proceso", driver:cnc.costoNC + cnc.costoOTsRech, unidad:`${cnc.ncsMes} NC + ${cnc.otsRech} OTs rechazadas/mes` },
            scrap:   { nombre:"🌿 Reducir Scrap / Trazabilidad FSC", desc:"Menos material descartado por desvío",             driver:cnc.costoScrap,    unidad:`${cnc.scrapMes}kg scrap/mes` },
          };
          const esc = ESCENARIOS[escSel];
          const ahorroMensual = esc.driver * (Number(reduccion)/100);
          const costoMensualNum = Number(costoMensual)||0;
          const beneficioNeto = ahorroMensual - costoMensualNum;
          const invInicialNum = Number(invInicial)||0;
          let paybackTxt;
          if (!cnc.configurado) paybackTxt = null;
          else if (invInicialNum===0 && beneficioNeto<=0) paybackTxt = "Cargá una inversión inicial o un % de reducción para calcular.";
          else if (beneficioNeto>0) {
            const meses = invInicialNum===0 ? 0 : Math.ceil(invInicialNum/beneficioNeto);
            paybackTxt = meses===0 ? "Sin inversión inicial cargada: el beneficio neto ya es positivo desde el mes 1." : `Se paga sola en ≈ ${meses} mes${meses===1?"":"es"}.`;
          } else {
            paybackTxt = "Con estos números, el costo mensual supera el ahorro estimado: no hay repago con este mix.";
          }
          return (
            <div style={{ ...card, background: oscuro?"#0a0a2e":"#faf5ff", border:`1.5px solid #7B5BF240` }}>
              <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:"14px" }}>
                <div>
                  <h3 style={{ fontSize:"14px", fontWeight:"800", color:"#7B5BF2", margin:"0 0 2px" }}>💡 Simulador de Decisiones — ROI</h3>
                  <p style={{ fontSize:"11px", color:subtexto, margin:0 }}>Calculado con tus datos reales de Costos de No Calidad · Exclusivo Dirección</p>
                </div>
                <button onClick={() => setMostrarSim(v=>!v)} style={{ padding:"6px 12px", background:mostrarSim?"#7B5BF2":"transparent", border:"1.5px solid #7B5BF2", borderRadius:"8px", cursor:"pointer", fontSize:"11px", color:mostrarSim?"white":"#7B5BF2", fontWeight:"600" }}>
                  {mostrarSim ? "Ocultar" : "Simular una decisión"}
                </button>
              </div>
              {mostrarSim && !cnc.configurado && (
                <p style={{ fontSize:"12px", color:subtexto }}>Primero configurá los costos en el módulo Costos de No Calidad — sin eso no hay datos reales para simular.</p>
              )}
              {mostrarSim && cnc.configurado && (
                <div>
                  <div style={{ display:"flex", gap:"8px", flexWrap:"wrap", marginBottom:"14px" }}>
                    {Object.entries(ESCENARIOS).map(([key,e]) => (
                      <button key={key} onClick={() => setEscSel(key)}
                        style={{ padding:"10px 14px", borderRadius:"10px", border:`1.5px solid ${escSel===key?"#7B5BF2":borde}`, background:escSel===key?"#f5f3ff":cardBg, cursor:"pointer", textAlign:"left", flex:"1 1 200px" }}>
                        <p style={{ fontSize:"12px", fontWeight:"700", color:escSel===key?"#7B5BF2":texto, margin:"0 0 3px" }}>{e.nombre}</p>
                        <p style={{ fontSize:"10.5px", color:subtexto, margin:0 }}>{e.desc}</p>
                      </button>
                    ))}
                  </div>
                  <div style={{ background: oscuro?"#050e2e":"#eff6ff", borderRadius:"10px", padding:"10px 14px", marginBottom:"14px" }}>
                    <p style={{ fontSize:"11px", color:subtexto, margin:0 }}>Costo real actual de este problema (mes en curso)</p>
                    <p style={{ fontSize:"20px", fontWeight:"800", color:"#e63946", margin:"2px 0" }}>${Math.round(esc.driver).toLocaleString('es-AR')}/mes</p>
                    <p style={{ fontSize:"10.5px", color:subtexto, margin:0 }}>{esc.unidad}</p>
                  </div>
                  <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:"10px", marginBottom:"14px" }}>
                    <div>
                      <label style={{ fontSize:"10.5px", fontWeight:"600", color:subtexto, display:"block", marginBottom:"4px" }}>Inversión inicial ($)</label>
                      <input type="number" value={invInicial} onChange={e=>setInvInicial(e.target.value)} placeholder="0" style={{ width:"100%", padding:"7px 9px", borderRadius:"8px", border:`1px solid ${borde}`, fontSize:"12px", background:cardBg, color:texto }}/>
                    </div>
                    <div>
                      <label style={{ fontSize:"10.5px", fontWeight:"600", color:subtexto, display:"block", marginBottom:"4px" }}>Costo mensual extra ($)</label>
                      <input type="number" value={costoMensual} onChange={e=>setCostoMensual(e.target.value)} placeholder="0" style={{ width:"100%", padding:"7px 9px", borderRadius:"8px", border:`1px solid ${borde}`, fontSize:"12px", background:cardBg, color:texto }}/>
                    </div>
                    <div>
                      <label style={{ fontSize:"10.5px", fontWeight:"600", color:subtexto, display:"block", marginBottom:"4px" }}>% reducción esperada</label>
                      <input type="number" min="0" max="100" value={reduccion} onChange={e=>setReduccion(e.target.value)} style={{ width:"100%", padding:"7px 9px", borderRadius:"8px", border:`1px solid ${borde}`, fontSize:"12px", background:cardBg, color:texto }}/>
                    </div>
                  </div>
                  <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:"10px", marginBottom:"10px" }}>
                    <div style={{ background: oscuro?"#0a1f0a":"#f0fdf4", borderRadius:"10px", padding:"10px 14px" }}>
                      <p style={{ fontSize:"10.5px", color:subtexto, margin:0 }}>Ahorro mensual estimado</p>
                      <p style={{ fontSize:"18px", fontWeight:"800", color:"#22c55e", margin:0 }}>${Math.round(ahorroMensual).toLocaleString('es-AR')}</p>
                    </div>
                    <div style={{ background: beneficioNeto>=0?(oscuro?"#0a1f0a":"#f0fdf4"):(oscuro?"#1a0505":"#fff5f5"), borderRadius:"10px", padding:"10px 14px" }}>
                      <p style={{ fontSize:"10.5px", color:subtexto, margin:0 }}>Beneficio neto mensual</p>
                      <p style={{ fontSize:"18px", fontWeight:"800", color:beneficioNeto>=0?"#22c55e":"#e63946", margin:0 }}>${Math.round(beneficioNeto).toLocaleString('es-AR')}</p>
                    </div>
                  </div>
                  {paybackTxt && (
                    <div style={{ background:"#7B5BF215", border:"1px solid #7B5BF240", borderRadius:"10px", padding:"10px 14px" }}>
                      <p style={{ fontSize:"12.5px", fontWeight:"700", color:"#7B5BF2", margin:0 }}>{paybackTxt}</p>
                    </div>
                  )}
                  <p style={{ fontSize:"10px", color:subtexto, marginTop:"10px" }}>
                    El "costo real actual" sale de tus datos de este mes en ALQOS. La inversión, el costo mensual extra y el % de reducción esperada los estimás vos según la propuesta que estés evaluando.
                  </p>
                </div>
              )}
            </div>
          );
        })()}
        <p style={{ fontSize:"11px", color:subtexto, textAlign:"center", marginTop:"1rem" }}>
          ALQOS™ by QORVEX · Dashboard CA · Actualización automática cada 30s
        </p>
      </div>
    </div>
  );
}
